/**
 * Lightens or darkens a hex color by a specified amount.
 *
 * @param {string} col - The hex color code to modify (with or without the '#' prefix)
 * @param {number} amt - The amount to lighten (positive) or darken (negative) the color
 * @returns {string} A new hex color code with the adjusted brightness
 */
export const lightenOrDarkenColor = (col: string, amt: number): string => {
    // Remove the '#' if it's there
    col = col?.replace(/^#/, '');

    // Parse the color to an integer
    let num = parseInt(col, 16);

    // Extract the RGB values
    let r = (num >> 16) + amt; // Red
    let g = ((num >> 8) & 0x00ff) + amt; // Green
    let b = (num & 0x0000ff) + amt; // Blue

    // Ensure RGB values are within bounds (0-255)
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    // Combine the values back into a single hex string
    const newColor = (r << 16) | (g << 8) | b;
    return `#${newColor.toString(16).padStart(6, '0').toUpperCase()}`;
};
